import { FileName } from "./ubiquitousTypes"
import { PpeActionRecordSchema } from "../models/ppe"
import { ProfilePk } from "."

export type ProfileSyncSessionId = string

export enum BaseProfileKey {
  employment = "employment",
  competencies = "competencies",
  discipline = "discipline",
  adHocDocs = "adHocDocs",
  adHocData = "adHocData",
  ppe = "ppe",
  generalDataByTimestamp = "generalDataByTimestamp",
}

export type RecordId = string
export type RawData = Record<string, any>

export type AdhocEventRecordSchema = {
  uid: RecordId
  docs: FileName[]
  rawData: RawData
  logs?: Record<string, any>[]
  previousRawData: RawData
}

export type EmploymentEventSchema = {
  uid: RecordId
  docs: FileName[]
  rawData: RawData
  photos?: FileName[]
  logs?: Record<string, any>[]
  previousRawData: RawData
}

export type DisciplineEventSchema = {
  uid: RecordId
  docs: FileName[]
  rawData: RawData
  photos?: FileName[]
  logs?: Record<string, any>[]
  uiData?: Record<string, any>
  previousRawData: RawData
}

export type RecordLog = {
  op: string
  path: string
  value?: any
  unixMs: number
  idPassport: ProfilePk
  uid: string
  recordType: BaseProfileKey
  previousValue: any
}

export type ProfileEventRecord = (
  | AdhocEventRecordSchema
  | EmploymentEventSchema
  | DisciplineEventSchema
  | PpeActionRecordSchema
) & { recordType: BaseProfileKey }
